/* eslint-disable i18next/no-literal-string */
import React from 'react';
import { Button } from 'react-bootstrap';
import { ReactComponent as StarIcon } from 'assets/images/gen-ai-image-landing/star.svg';
import { ReactComponent as CoinIcon } from 'assets/images/Auto-Coin.svg';
import { useHistory } from 'react-router-dom';
import styles from './TryNow.module.scss';

export default function TryNow() {
  const history = useHistory();

  return (
    <div className={styles.tryNowSection}>
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.topText}>Enjoy 5 free photos</div>
          <div className={styles.subtitle}>(each rendered with 2 variants)</div>
        </div>

        <div className={styles.mainText}>TRY NOW</div>

        <div className={styles.decorativeSection}>
          <div className={styles.horizontalLine} />
          <div className={styles.verticalLine} />

          <div className={styles.decorativeStar}>
            <StarIcon />
          </div>

          <div className={styles.coinSection}>
            <div className={styles.coinIcon}>
              <CoinIcon />
            </div>
            <div className={styles.coinText}>Then 1 coin = 5 photos</div>
          </div>

          <Button
            className={styles.ctaButton}
            onClick={() => {
              history.push('/get-started');
            }}
          >
            Free Sign Up Now
          </Button>
        </div>

        <div className={styles.bottomText}>Each photo is rendered with 2 variants</div>
      </div>
    </div>
  );
}
